
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';

@Component
export default class Add2CartOnProductPage extends Vue {
  @Prop()
  private domAdd2CartSelector: string;

  private domAdd2CartButtonDetected = false;

  mounted() {
    this.$x.on(EVENTS.RebindDomEvents).subscribe(this.onDomSelectorChange);
  }

  @Watch('domAdd2CartSelector', { immediate: true })
  onDomSelectorChange() {
    if (!this.domAdd2CartButtonDetected && this.obtainDomAdd2CartButton()) {
      this.$x.emit(EVENTS.ProductPageDetected);
      this.domAdd2CartButtonDetected = true;
    }
    this.updateDomListeners();
  }

  obtainDomAdd2CartButton(): HTMLElement {
    return document.querySelector(this.domAdd2CartSelector) as HTMLElement;
  }

  updateDomListeners() {
    document.removeEventListener('click', this.eventListener);
    document.addEventListener('click', this.eventListener);
  }

  eventListener(event: Event) {
    const domAdd2CartButton = this.obtainDomAdd2CartButton();
    const target  = event.target as HTMLElement;
    if (domAdd2CartButton && (target === domAdd2CartButton || domAdd2CartButton.contains(target))) {
      this.onAdd2CartClicked();
    }
  }

  onAdd2CartClicked() {
    this.$x.emit(EVENTS.Add2CartOnProductPageClicked);
  }

  render() {}
}
